import http from './http';

export default class BaseService {
  constructor() {
    http.interceptors.response.use((response) => response, (error) => Promise.resolve(error.response));
  }
  handleStatusCode(response) {
    if (!response || !response.status) {
      // Erro de timeout ou servidor
      return false;
    }
    switch (response.status) {
      case 200:
        // success
        return true;
      case 400:
        // bad request
        return false;
      case 401:
        // Unauthorized
        return false;
      case 500:
        // Internal Server Error
        return false;
      default:
        return true;
    }
  }

  handleResponse(response) {
    if (!this.handleStatusCode(response)) return null;
    return response;
  }

  getHeaders() {
    const headers = {};
    headers['Content-type'] = 'application/json';
    headers.authorization = this.$store.getters.token;
    return headers;
  }

  async getAsync(url) {
    try {
      const headers = this.getHeaders();
      const response = await http.get(url, { headers });
      return this.handleResponse(response);
    } catch (err) {
      return this.handleResponse(err.response);
    }
  }

  async getAsyncBuffer(url) {
    try {
      const response = await http.get(url, { responseType: 'arraybuffer' });
      return this.handleResponse(response);
    } catch (err) {
      return this.handleResponse(err.response);
    }
  }

  async postAsync(url, body) {
    try {
      const headers = this.getHeaders();
      const response = await http.post(url, body, { headers });
      return this.handleResponse(response);
    } catch (err) {
      return this.handleResponse(err.response);
    }
  }

  async putAsync(url, body) {
    try {
      const headers = this.getHeaders();
      const response = await http.put(url, body, { headers });
      return this.handleResponse(response);
    } catch (err) {
      return this.handleResponse(err.response);
    }
  }

  async patchAsync(url, body) {
    try {
      const headers = this.getHeaders();
      const response = await http.patch(url, body, { headers });
      return this.handleResponse(response);
    } catch (err) {
      return this.handleResponse(err.response);
    }
  }

  async deleteAsync(url, body) {
    try {
      const newUrl = `${url}?id=${body}`;
      const headers = this.getHeaders();
      const response = await http.put(newUrl, body, { headers });
      return this.handleResponse(response);
    } catch (err) {
      return this.handleResponse(err.response);
    }
  }
}
